export const GRAPH_URL =
  "https://subgraph.satsuma-prod.com/09c9cf3574cc/orbital-apes/OrbitMarket/api";
